import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { ChartTheme, ILoadedEventArgs } from '@syncfusion/ej2-angular-charts';


@Component({
  selector: 'app-metric-chart-multi-series-staff',
  templateUrl: './metric-chart-multi-series-staff.component.html',
  styleUrls: ['./metric-chart-multi-series-staff.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService]

})
export class MetricChartMultiSeriesStaffComponent implements OnInit {

  // public data: Object[] = [];
  
  @Input() sent_data?: any; // not used

  // public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;
  @ViewChild('grid3') public grid3: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;

  public groupOptions: GroupSettingsModel;
  // public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both



     // setup as observable?
     @Input() item_id?: any; // impliments on changes.
     @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;








  public chartArea: Object = {
    border: {
        width: 0
    }
};
public width: string = Browser.isDevice ? '100%' : '75%';

public data: Object[] = [
//   { x: '2005', y: 1.2, y1: 0.5, y2: 0.7, y3: -0.8, y4: 1.5},
// { x: '2006', y: 1, y1: 0.5, y2: 1.4, y3: 0, y4: 2.3 },
// { x: '2007', y: 1, y1: 0.5, y2: 1.5, y3: -1, y4: 2 },
// { x: '2008', y: 0.25, y1: 0.35, y2: 0.35, y3: -.35, y4: 0.1 },
// { x: '2009', y: 0.1, y1: 0.9, y2: -2.7, y3: -0.3, y4: -2.7 },
// { x: '2010', y: 1, y1: 0.5, y2: 0.5, y3: -0.5, y4: 1.8 },
// { x: '2011', y: 0.1, y1: 0.25, y2: 0.25, y3: 0, y4: 2 },
// { x: '2012', y: -0.25, y1: -0.5, y2: -0.1, y3: -0.4, y4: 0.4 },
// { x: '2013', y: 0.25, y1: 0.5, y2: -0.3, y3: 0, y4: 0.9 },
// { x: '2014', y: 0.6, y1: 0.6, y2: -0.6, y3: -0.6, y4: 0.4 },
// { x: '2015', y: 0.9, y1: 0.5, y2: 0, y3: -0.3, y4: 1.3 }
];
//Initializing Primary X Axis
public primaryXAxis: Object = {
    title: 'System Actions / KPI',
    interval: Browser.isDevice ? 2 : 1,
    labelIntersectAction: 'Rotate45',
    valueType: 'Category',
    majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
    majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
    lineStyle: { width: 0 },
};
//Initializing Primary Y Axis
public primaryYAxis: Object = {
    title: 'Counts (KIP Items)',
    minimum: 0,
    // maximum: 10000,
    // interval: 100,
    lineStyle: { width: 0 },
    majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
    minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
    labelFormat: '{value}',
};
public legend: Object = {
    visible: true,
    enableHighlight : true
};
public title: string = 'Staff Group Activity + Performance';
public marker1: Object = {
    visible: true,
    width: 7,
    height: 7
};
  woo_orders: any;
  search_results: any;
  Chart4_all_data: { }[];
  count_item_data: number;
  item_data_user_logs_array: any;
  item_data_user_logs_array_count: number;
  Chart5_all_data: any[];

// custom code start
public load(args: ILoadedEventArgs): void {
    let selectedTheme: string = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Fluent2';
    args.chart.theme = <ChartTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark").replace(/contrast/i, 'Contrast').replace(/-highContrast/i, 'HighContrast');
};
// custom code end
public tooltip: Object = {
    enable: true
};










  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private modalService: BsModalService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private _mysqlService: MysqlService,

  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes) {

    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.item_id = changes.item_id.currentValue;
    }

    if (changes.item_data) {

      this.woo_orders = changes.item_data.currentValue;
      setTimeout(() => {  
      
        this.systemLogNumbers(this.woo_orders)
         // New seperate
         // this.load_Chart1(this.woo_orders)


       }, 1000);


    }



  }





  systemLogNumbers(send_data){
 

    this.search_results = this.woo_orders; // works for meta pass - not direct orders via mysql?
  

    var Chart4_created_by_full_logs = this.search_results;
          
    var result00_Chart4_created_by_full_logs = _.map(_.keys(Chart4_created_by_full_logs), function(e) {
      return _.reduce(Chart4_created_by_full_logs[e], function(r, o) {
       //  return r.count += +o.log_id, r
        return r
     },
    //  2023-05-20T12:44:00+1000
    //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
    //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
    //  {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: new Date( Chart2_users_group[e].created_date)})
    //  {log_type_name: Chart4_created_by_full_logs[e].log_type_name, sum: Chart4_created_by_full_logs[e].length, color: "yellow", created_date: new Date( Chart4_created_by_full_logs[e].created_date)})
    //  {x: Chart4_created_by_full_logs[e].name, y: 300, y1: 60}
    //  {x: Chart4_created_by_full_logs[e].name, y: 30, y1: 600, y2: 750, y3: 6033, y4: 6000, y5: 3,  }
     {x: Chart4_created_by_full_logs[e].name, y: 5, y1: 600, y2: 750, y3: 6033, y4: 6000, y5: 3,  }
    
    )
   
   
    })



// Lets build a manual loop and set the model the way I know how by counting and looping through the results t set the appropriate data models.
// User a bove and for for each user build an array of all the [user_logs_array] if exists 
// with each of these items in the list, each y1: (log_type_name, : we need the counts)     (user_login: 33) --  y1: -- log type id___ we need to make it so....






    this.Chart4_all_data  = result00_Chart4_created_by_full_logs
















// Lets Start a chart 5 / This will be the automatic chart based on the data

    this.count_item_data = Object.keys(this.item_data).length;


    var item_data_array = [];
    this.item_data_user_logs_array = [];

    // 1: We first get the array of [user_logs_array] from the items_data row, and set it as its own model to loop.
    for(let i=0;i < this.count_item_data; i++) {
      let res = this.item_data[i];
      let count_y1 = this.item_data[i]['user_logs_array'].lenght;
      let user_logs_array = this.item_data[i].user_logs_array;
               // Flattern the return s grid can read the data
              //  if(this.item_data[i]){}
              //   item_data_array.push({
              //         x: res.name,
              //         y: user_logs_array,
              //         y1: 600,
              //         y2: 750,
              //         y3: 6033,
              //         y4: 6000,
              //         y5: 3,
              //     // ...this.logs_search_kPI_benchmarks_global[0][i]
              //   })
              
                if(user_logs_array){
                  this.item_data_user_logs_array.push({
                    ...user_logs_array
                  })
                }
                

    }

    //2 : Loop throught the model an setup the templated model for the graphs/charts
    // Now need to loop through this and build the array items..     [item_data_user_logs_array]

    // All below is a for loop... I need to do a while loop on the 

    this.item_data_user_logs_array_count = Object.keys(this.item_data_user_logs_array).length;








if(this.item_data_user_logs_array_count >= 1){




  var list = [1 , 2, 3, 4, 5];


  _.forEach(this.item_data_user_logs_array, function(value) {
    // console.log('For Each: ' + JSON.stringify(value));

    var y1;
    
    if( value.log_type_name == 'user_login'){
       y1 = value.count;
        console.log ('y1: ' + y1 )
      }



    var result00_Chart5_created_by_full_logs = _.map(_.keys(value), function(e) {
      return _.reduce(Chart4_created_by_full_logs[e], function(r, o) {
       //  return r.count += +o.log_id, r


        return r
     },

  
    //  2023-05-20T12:44:00+1000
    //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
    //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
    //  {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: new Date( Chart2_users_group[e].created_date)})
    //  {log_type_name: Chart4_created_by_full_logs[e].log_type_name, sum: Chart4_created_by_full_logs[e].length, color: "yellow", created_date: new Date( Chart4_created_by_full_logs[e].created_date)})
    //  {x: Chart4_created_by_full_logs[e].name, y: 300, y1: 60}
    //  {x: Chart4_created_by_full_logs[e].name, y: 30, y1: 600, y2: 750, y3: 6033, y4: 6000, y5: 3,  }
     {x: value[e].name, y: value[e].count,
      y1:  y1, 
      // y2: 750, y3: 6033, y4: 6000, y5: 3,
       log_type_name: value[e].log_type_name, }
    
    )


// if value = user_login = variable y1 y etc....

   
   
    })
    console.log('REDUCER iNSIDE EACH: ' + JSON.stringify(result00_Chart5_created_by_full_logs))



 });























    for(let ii=0;ii < this.item_data_user_logs_array_count; ii++) {
      let res_ = this.item_data_user_logs_array[ii];
                     // Flattern the return s grid can read the data


// This is the wrong order I will need to do the other way, and map and then set the cout variables for each type, otherwise the order of the arrays are immposinle to determin, I need to get by the ID

                     let name = '';
                     let y=0;
                     let y1=0;
                     let y2=0;
                     let y3=0;
                     let data = res_;
                     if(data[0]){
                     name =  data[0].name
                     y =  data[0].count
                     }
                     if(data[1]){
                      y1 =  data[1].count



                      var result00_Chart5_created_by_full_logs = _.map(_.keys(data), function(e) {
                        return _.reduce(Chart4_created_by_full_logs[e], function(r, o) {
                         //  return r.count += +o.log_id, r
                          return r
                       },
                      //  2023-05-20T12:44:00+1000
                      //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
                      //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
                      //  {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: new Date( Chart2_users_group[e].created_date)})
                      //  {log_type_name: Chart4_created_by_full_logs[e].log_type_name, sum: Chart4_created_by_full_logs[e].length, color: "yellow", created_date: new Date( Chart4_created_by_full_logs[e].created_date)})
                      //  {x: Chart4_created_by_full_logs[e].name, y: 300, y1: 60}
                      //  {x: Chart4_created_by_full_logs[e].name, y: 30, y1: 600, y2: 750, y3: 6033, y4: 6000, y5: 3,  }
                       {x: Chart4_created_by_full_logs[e].name, y: 5, y1: 444, y2: 750, y3: 6033, y4: 6000, y5: 3,  }
                      
                      )
                     
                     
                      })
                    
                    
                    console.log('REDUCER: ' + JSON.stringify(result00_Chart5_created_by_full_logs))



                      }// end if
                      if(data[2]){
                        y2 =  data[2].count
                        }
                      if(data[3]){
                        y3 =  data[3].count
                        }




                        let arr =  data;
      
                  // I need to sort out for each of these items group by log_type_id and set the appropriate y: values --
//
// a: function to get count, name from the items. from the log_type_ids, and only get ones with data, and a "name" value, if there is no name value this means it is not part of bthe benchmark KIP array.....





                      // do a reduce filter to get the variable I need to set for y1: y2" etc... this should work for the approach...
        
console.log('Count Value ' + JSON.stringify(data))
        if(data[0]){
                item_data_array.push({
                      x: name,
                      y: y,
                      y1: y1,
                      y2: y2,
                      y3: y3,
                      // y4: 6000,
                      // y5: 3,
                  // ...this.logs_search_kPI_benchmarks_global[0][i]
                })
              }

    }
}

    this.Chart5_all_data  = item_data_array








  }












}
